<!-- Intro Header -->
<header class="sdg-home">
  <div class="intro-body">
    <div class="container">
      <div class="row home-sdg-page">
        <div class="col-md-12">
          <h5 class="brand-heading text-center" i18n>SDG 6 Policy Support System</h5>
        </div>
        <div class="col-md-12">
          <a (click) = "statusBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle " style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; ">
            <i class="fa fa-line-chart animated" aria-hidden="true"></i>
            <p i18n>Status</p>
          </a>
          <a (click) = "capacityBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle " style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; ">
            <i class="fa fa-tachometer animated" aria-hidden="true"></i>
            <p i18n>Capacity</p>
          </a>
          <a (click) = "financeBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle " style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; ">
            <i class="fa fa-usd animated" aria-hidden="true"></i>
            <p i18n>Finance</p>
          </a>
          <a (click) = "policyBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle " style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; ">
            <i class="fa fa-file-text-o animated" aria-hidden="true"></i>
            <p i18n="@@Policy round">Policy & Institutional</p>
          </a>
          <a (click) = "genderBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle " style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; ">
            <i class="fa fa-venus animated" aria-hidden="true"></i>
            <p i18n>Gender</p>
          </a>
          <a (click) = "resilienceBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle " style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; ">
            <i class="fa fa-bolt animated" aria-hidden="true"></i>
            <p i18n>DRR/Resilience</p>
          </a>
          <a (click) = "integrityBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle " style="margin-bottom: 15px; padding-top:12px; padding-bottom: 12px; ">
            <i class="fa fa-search animated" aria-hidden="true"></i>
            <p i18n>Integrity</p>
          </a>
        </div>

        <div class="clearfix"></div>
        <div class="col-md-12 text-center" style="margin-top: 100px;">
         <a class="btn btn-default btn-radius btn-lg" (click) = "viewSummaryBtnClick()" style="min-width:150px;" i18n="@@Summary View short">Summary View</a>
        </div>
      </div>
    </div>
  </div>
</header>



// WEBPACK FOOTER //
// ./src/app/sdg/sdg-home/sdg-home.component.html